import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./Mypayments.css";
import Navbar from "../../../Shared/ManagerNavbar/Navbar";
import { baseURL } from "../../../Apiservices/Api";
import { FaEdit, FaTrash } from "react-icons/fa";
import DataTable from "../../../Layout/Table/TableLayout";
import axios from 'axios';
import { AuthContext } from '../../../AuthContext/AuthContext';


const M_MyPaymentsPage = () => {
    const { leadid } = useParams();
    const { userId, userName } = useContext(AuthContext);
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);

    const [customer, setCustomer] = useState(null);
    const [receivables, setReceivables] = useState([]);
    const [activeTab, setActiveTab] = useState("receivables");

    const [isEditingAmount, setIsEditingAmount] = useState(false);
    const [editedAmount, setEditedAmount] = useState("");

    // Fetch lead and opportunity data
    useEffect(() => {
        // Get lead data
        fetch(`${baseURL}/api/leads/${leadid}`)
            .then((res) => res.json())
            .then((data) => {
                setCustomer((prev) => ({
                    ...prev,
                    leadid: data.leadid,
                    customerid: data.customerid,
                    name: data.name,
                    email: data.email,
                }));
            })
            .catch((err) => console.error("Error fetching lead:", err));

        // Get travel opportunity data
        fetch(`${baseURL}/travel-opportunity`)
            .then((res) => res.json())
            .then((data) => {
                const matchedOpportunity = data.find(item => item.leadid == leadid);
                if (matchedOpportunity) {
                    setCustomer((prev) => ({
                        ...prev,
                        id: matchedOpportunity.id,
                        totalAmount: matchedOpportunity.approx_budget,
                    }));
                    setEditedAmount(matchedOpportunity.approx_budget);
                }
            })
            .catch((err) => console.error("Error fetching travel opportunities:", err));
    }, [leadid]);

    // Fetch payment data
    // useEffect(() => {
    //     fetch(`${baseURL}/api/payments?leadid=${leadid}`)
    //         .then((res) => res.json())
    //         .then((data) => {
    //             // Sort payments by date (oldest first) for accurate cumulative calculation
    //             const sortedPayments = [...data].sort((a, b) => new Date(a.paid_on) - new Date(b.paid_on));
    //             setReceivables(sortedPayments);
    //         })
    //         .catch((err) => console.error("Error fetching receivables:", err));
    // }, [leadid]);

// Fetch and sort receivables by paid_on and created_at
    useEffect(() => {
    fetch(`${baseURL}/api/payments?leadid=${leadid}`)
        .then((res) => res.json())
        .then((data) => {
            // Sort payments by paid_on (ascending) and then by created_at (ascending)
            const sortedPayments = [...data].sort((a, b) => {
                const dateCompare = new Date(a.paid_on) - new Date(b.paid_on);
                if (dateCompare !== 0) return dateCompare;
                
                // If paid_on dates are equal, sort by created_at
                return new Date(a.created_at) - new Date(b.created_at);
            });
            setReceivables(sortedPayments);
        })
        .catch((err) => console.error("Error fetching receivables:", err));
}, [leadid]);

    // Calculate cumulative balance for each payment
    const getPaymentsWithBalance = () => {
        if (!customer || !customer.totalAmount) return [];
        
        let runningBalance = customer.totalAmount;
        return receivables.map(payment => {
            const paidAmount = parseFloat(payment.paid_amount) || 0;
            runningBalance -= paidAmount;
            return {
                ...payment,
                balance_amount: runningBalance.toFixed(2)
            };
        });
    };

    const handleSaveAmount = () => {
        fetch(`${baseURL}/travel-opportunity/${customer.id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                approx_budget: editedAmount,
                leadid: customer.leadid,      
                userid: userId   
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                setCustomer((prev) => ({
                    ...prev,
                    totalAmount: editedAmount,
                }));
                setIsEditingAmount(false);
                alert("Total amount updated successfully!");
            })
            .catch((err) => {
                console.error("Error updating total amount:", err);
                alert("Failed to update total amount.");
            });
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this receivable?")) {
          try {
            const res = await axios.delete(`${baseURL}/api/delete/receivables/${id}`);
            alert(res.data.message);
      
            // Update UI (remove deleted item from state)
            setReceivables(prev => prev.filter(item => item.id !== id));
          } catch (err) {
            console.error("Delete error:", err);
            alert("Failed to delete receivable.");
          }
        }
    };

    if (!customer) {
        return <div className="payments-container">Loading lead info...</div>;
    }

    const paymentsWithBalance = getPaymentsWithBalance();
    const totalPaid = receivables.reduce(
        (acc, curr) => acc + parseFloat(curr.paid_amount || 0),
        0
    );
    const balanceRemaining = customer.totalAmount - totalPaid;

    const tableColumns = [
        {
            Header: "S.No",
            accessor: (_, rowIndex) => rowIndex + 1,
            Cell: ({ row }) => row.index + 1,
        },
        {
            Header: "Received On",
            accessor: row => new Date(row.paid_on).toLocaleDateString("en-IN", {
              timeZone: "Asia/Kolkata"
            })
          },
        { 
            Header: "Received Amount", 
            accessor: "paid_amount", 
            Cell: ({ value }) => `₹${parseFloat(value).toFixed(2)}` 
        },
        { 
            Header: "Balance Amount", 
            accessor: "balance_amount",
            Cell: ({ row }) => {
                const balance = row.original.balance_amount || 
                    (customer.totalAmount - 
                     paymentsWithBalance.slice(0, row.index + 1).reduce(
                        (sum, p) => sum + parseFloat(p.paid_amount || 0), 0
                     )).toFixed(2);
                return `₹${balance}`;
            }
        },
        { Header: "Remarks", accessor: "remarks" },
        { Header: "Status", accessor: "status" },
        {
            Header: "Action",
            Cell: ({ row }) => (
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <FaEdit
                        style={{ color: "#ff9966", cursor: "pointer" }}
                        onClick={() => navigate(`/m-edit-mypayment/${row.original.leadid}/${row.original.id}`)}
                    />
                    <FaTrash
                        style={{ color: "#ff9966", cursor: "pointer" }}
                        onClick={() => handleDelete(row.original.id)}
                    />
                </div>
            ),
        }
    ];

    return (
        <div className="salesViewLeadsContainer">
            <Navbar onToggleSidebar={setCollapsed} />
            <div className={`salesViewLeads ${collapsed ? "collapsed" : ""}`}>
                <div className="payments-tabs">
                    <button
                        className={activeTab === "payables" ? "active" : ""}
                        onClick={() => {
                            setActiveTab("payables");
                            navigate(`/m-mysupplier/${leadid}`);
                        }}
                    >
                        Payables
                    </button>
                    <button
                        className={activeTab === "receivables" ? "active" : ""}
                        onClick={() => setActiveTab("receivables")}
                    >
                        Receivables
                    </button>
                </div>

                <h2>Receivables - Lead ID: {customer.leadid}</h2>

                <div className="totals-summary" style={{
                    margin: "20px 0",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #ddd",
                    padding: "15px",
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "space-around",
                    fontWeight: "bold"
                }}>
                    <span>Name: {customer.name}</span>
                    <span>Email: {customer.email}</span>

                    <span>
                        Total Amount: ₹
                        {isEditingAmount ? (
                            <>
                                <input
                                    type="number"
                                    value={editedAmount}
                                    onChange={(e) => setEditedAmount(e.target.value)}
                                    style={{ width: "100px", marginRight: "5px" }}
                                />
                                <button
                                    onClick={handleSaveAmount}
                                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                    title="Save"
                                >
                                    <i className="fas fa-check" style={{ color: 'green' }}></i>
                                </button>
                                <button
                                    onClick={() => setIsEditingAmount(false)}
                                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                    title="Cancel"
                                >
                                    <i className="fas fa-times" style={{ color: 'red' }}></i>
                                </button>
                            </>
                        ) : (
                            <>
                                {customer.totalAmount}
                                <button
                                    onClick={() => setIsEditingAmount(true)}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        marginLeft: '10px'
                                    }}
                                    title="Edit"
                                >
                                    <i className="fas fa-edit"></i>
                                </button>
                            </>
                        )}
                    </span>

                    <span>Total Received: ₹{totalPaid.toFixed(2)}</span>
                    <span>
                        Balance Remaining:{" "}
                        <span style={{ color: balanceRemaining > 0 ? "red" : "green" }}>
                            ₹{balanceRemaining.toFixed(2)}
                        </span>
                    </span>
                </div>

                {activeTab === "receivables" && (
                    <>
                        <div className="payments-table-header">
                            <button
                                className="btn btn-primary"
                                onClick={() => navigate(`/m-add-mypayment/${leadid}`)}
                            >
                                Add Receivables
                            </button>
                        </div>

                        {receivables.length > 0 ? (
                            <DataTable
                                columns={tableColumns}
                                data={paymentsWithBalance}
                                pagination
                                searchable
                            />
                        ) : (
                            <div className="no-payments-found">No Receivables found.</div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default M_MyPaymentsPage;

// const M_MyPaymentsPage = () => {
//     const { leadid } = useParams();
//     const navigate = useNavigate();
//     const [collapsed, setCollapsed] = useState(false);

//     const [customer, setCustomer] = useState(null);
//     const [receivables, setReceivables] = useState([]);
//     const [activeTab, setActiveTab] = useState("receivables");

//     const [isEditingAmount, setIsEditingAmount] = useState(false); // toggle edit mode
//     const [editedAmount, setEditedAmount] = useState(""); // temp input value

//     // Fetch lead and opportunity data
//     useEffect(() => {
//         // Get lead data
//         fetch(`${baseURL}/api/leads/${leadid}`)
//             .then((res) => res.json())
//             .then((data) => {
//                 setCustomer((prev) => ({
//                     ...prev,
//                     leadid: data.leadid,
//                     customerid: data.customerid,
//                     name: data.name,
//                     email: data.email,
//                 }));
//             })
//             .catch((err) => console.error("Error fetching lead:", err));

//         // Get travel opportunity data
//         fetch(`${baseURL}/travel-opportunity`)
//             .then((res) => res.json())
//             .then((data) => {
//                 const matchedOpportunity = data.find(item => item.leadid == leadid);
//                 if (matchedOpportunity) {
//                     setCustomer((prev) => ({
//                         ...prev,
//                         id: matchedOpportunity.id, // Store ID for update
//                         totalAmount: matchedOpportunity.approx_budget,
//                     }));
//                     setEditedAmount(matchedOpportunity.approx_budget);
//                 }
//             })
//             .catch((err) => console.error("Error fetching travel opportunities:", err));
//     }, [leadid]);

//     // Fetch payment data
//     useEffect(() => {
//         fetch(`${baseURL}/api/payments?leadid=${leadid}`)
//             .then((res) => res.json())
//             .then((data) => {
//                 setReceivables(data);
//             })
//             .catch((err) => console.error("Error fetching receivables:", err));
//     }, [leadid]);

//     // Save updated amount to backend
//     const handleSaveAmount = () => {
//         fetch(`${baseURL}/travel-opportunity/${customer.id}`, {
//             method: "PUT",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//                 approx_budget: editedAmount,
//             }),
//         })
//             .then((res) => res.json())
//             .then((data) => {
//                 setCustomer((prev) => ({
//                     ...prev,
//                     totalAmount: editedAmount,
//                 }));
//                 setIsEditingAmount(false);
//                 alert("Total amount updated successfully!");
//             })
//             .catch((err) => {
//                 console.error("Error updating total amount:", err);
//                 alert("Failed to update total amount.");
//             });
//     };

//     const handleDelete = async (id) => {
//         if (window.confirm("Are you sure you want to delete this receivable?")) {
//           try {
//             const res = await axios.delete(`${baseURL}/api/delete/receivables/${id}`);
//             alert(res.data.message);
      
//             // Update UI (remove deleted item from state)
//             setReceivables(prev => prev.filter(item => item.id !== id));
//           } catch (err) {
//             console.error("Delete error:", err);
//             alert("Failed to delete receivable.");
//           }
//         }
//       };

//     if (!customer) {
//         return <div className="payments-container">Loading lead info...</div>;
//     }

//     const totalPaid = receivables.reduce(
//         (acc, curr) => acc + parseFloat(curr.paid_amount || 0),
//         0
//     );
//     const balanceRemaining = customer.totalAmount - totalPaid;

//     const tableColumns = [
//         {
//             Header: "S.No",
//             accessor: (_, rowIndex) => rowIndex + 1,
//             Cell: ({ row }) => row.index + 1,
//         },
//         { Header: "Total Amount", accessor: "total_amount", Cell: ({ value }) => `₹${value}` },
//         { Header: "Paid Amount", accessor: "paid_amount", Cell: ({ value }) => `₹${value}` },
//         { Header: "Balance Amount", accessor: "balance_amount", Cell: ({ value }) => `₹${value}` },
//         { Header: "Paid On", accessor: "paid_on" },
//         { Header: "Remarks", accessor: "remarks" },
//         { Header: "Status", accessor: "status" },
//         {
//             Header: "Action",
//             Cell: ({ row }) => (
//                 <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                     <FaEdit
//                         style={{ color: "#ff9966", cursor: "pointer" }}
//                         onClick={() => navigate(`/m-edit-mypayment/${row.original.leadid}/${row.original.id}`)}
//                     />
//                     <FaTrash
//                   style={{ color: "#ff9966", cursor: "pointer" }}
//                   onClick={() => handleDelete(row.original.id)}
//                 />
//                 </div>
//             ),
//         }
//     ];

//     return (
//         <div className="salesViewLeadsContainer">
//             <Navbar onToggleSidebar={setCollapsed} />
//             <div className={`salesViewLeads ${collapsed ? "collapsed" : ""}`}>
//                 <div className="payments-tabs">
//                     <button
//                         className={activeTab === "payables" ? "active" : ""}
//                         onClick={() => {
//                             setActiveTab("payables");
//                             navigate(`/m-mysupplier/${leadid}`);
//                         }}
//                     >
//                         Payables
//                     </button>
//                     <button
//                         className={activeTab === "receivables" ? "active" : ""}
//                         onClick={() => setActiveTab("receivables")}
//                     >
//                         Receivables
//                     </button>
//                 </div>

//                 <h2>Payments - Lead ID: {customer.leadid}</h2>

//                 <div className="totals-summary" style={{
//                     margin: "20px 0",
//                     backgroundColor: "#f9f9f9",
//                     border: "1px solid #ddd",
//                     padding: "15px",
//                     borderRadius: "8px",
//                     display: "flex",
//                     justifyContent: "space-around",
//                     fontWeight: "bold"
//                 }}>
//                     <span>Name: {customer.name}</span>
//                     <span>Email: {customer.email}</span>

//                     <span>
//                         Total Amount: ₹
//                         {isEditingAmount ? (
//                             <>
//                                 <input
//                                     type="number"
//                                     value={editedAmount}
//                                     onChange={(e) => setEditedAmount(e.target.value)}
//                                     style={{ width: "100px", marginRight: "5px" }}
//                                 />
//                                 <button
//                                     onClick={handleSaveAmount}
//                                     style={{ background: 'none', border: 'none', cursor: 'pointer' }}
//                                     title="Save"
//                                 >
//                                     <i className="fas fa-check" style={{ color: 'green' }}></i>
//                                 </button>
//                                 <button
//                                     onClick={() => setIsEditingAmount(false)}
//                                     style={{ background: 'none', border: 'none', cursor: 'pointer' }}
//                                     title="Cancel"
//                                 >
//                                     <i className="fas fa-times" style={{ color: 'red' }}></i>
//                                 </button>
//                             </>
//                         ) : (
//                             <>
//                                 {customer.totalAmount}
//                                 <button
//                                     onClick={() => setIsEditingAmount(true)}
//                                     style={{
//                                         background: 'none',
//                                         border: 'none',
//                                         cursor: 'pointer',
//                                         marginLeft: '10px'
//                                     }}
//                                     title="Edit"
//                                 >
//                                     <i className="fas fa-edit"></i>
//                                 </button>
//                             </>
//                         )}
//                     </span>

//                     <span>Total Paid: ₹{totalPaid}</span>
//                     <span>
//                         Balance Remaining:{" "}
//                         <span style={{ color: balanceRemaining > 0 ? "red" : "green" }}>
//                             ₹{balanceRemaining}
//                         </span>
//                     </span>
//                 </div>

//                 {activeTab === "receivables" && (
//                     <>
//                         <div className="payments-table-header">
//                             <button
//                                 className="btn btn-primary"
//                                 onClick={() => navigate(`/m-add-mypayment/${leadid}`)}
//                             >
//                                 Add Payment
//                             </button>
//                         </div>

//                         {receivables.length > 0 ? (
//                             <DataTable
//                                 columns={tableColumns}
//                                 data={receivables}
//                                 pagination
//                                 searchable
//                             />
//                         ) : (
//                             <div className="no-payments-found">No payments found.</div>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default M_MyPaymentsPage;
